module.exports = __webpack_public_path__ + "static/img/19.908fc769.jpg";